export const STATIC_LINK_DRAWER = {
    dashboards: 'https://help.scananalytics.ru/dashbordy',
    reports: 'https://help.scananalytics.ru/rabota-s-otchyotami'
};
